import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router';
import { api, completeLogin, describeAuthRefusal } from '@/lib/api';
import { postLoginPath } from '@/lib/mcp-consent';
import { AuthCard } from './AuthCard';

interface VerifyResponse {
  accessToken: string;
}

export function MfaVerifyPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { data } = await api.post<VerifyResponse>('/platform/auth/mfa/verify', { code });
      // Só o access, em memória: o refresh chega no cookie platform_refresh (HttpOnly).
      completeLogin(data);
      // Com autorização de agente pendente, volta ao caminho fixo do consentimento.
      navigate(postLoginPath());
    } catch (err) {
      // 423 da conta bloqueada e 429 do limite por IP têm mensagem própria.
      setError(describeAuthRefusal(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthCard
      title="Verificar MFA"
      subtitle="Digite o código TOTP atual do seu app autenticador."
    >
      <form onSubmit={onSubmit}>
        {error && <div className="error-banner">{error}</div>}

        <div className="field">
          <label htmlFor="code">Código TOTP</label>
          <input
            id="code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            maxLength={6}
            required
          />
        </div>

        <button type="submit" className="btn" style={{ width: '100%' }} disabled={submitting}>
          {submitting ? 'Verificando…' : 'Entrar'}
        </button>

        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 13 }}>
          Perdeu acesso ao celular?{' '}
          <Link to="/login/mfa-recovery">Usar recovery code</Link>
        </div>
      </form>
    </AuthCard>
  );
}
